import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    NewsTab,
    LawsTab,
    // MapTab,
    LawsDigestsTab,
    LawsDigestsOldTab,
    NewsDigestsTab,
    StatisticsTab,
    ReportsTab,
    ThemeReportsTab,
    RiskCardTab,
    CalendarTab,
} from './tabs';
import { checkUserExpirationDateExpired } from '~utils/helpers';

function Nav({
    userToken,
    isNewsUserLogged,
    isLawsUserLogged,
    isNewsAvailable,
    isLawsAvailable,
    ecosystemFunctions,
    onClick,
}) {
    const isUserLogged = isNewsUserLogged || isLawsUserLogged;
    // console.log('___ECO___', ecosystemFunctions);
    return (
        <nav>
            {(!isUserLogged || (isNewsUserLogged && isNewsAvailable)) && <NewsTab onClick={onClick} />}
            {(!isUserLogged || (isLawsUserLogged && isLawsAvailable)) && <LawsTab onClick={onClick} />}
            {/* {(!isUserLogged || (isLawsUserLogged && isLawsAvailable)) && (
                <MapTab onClick={onClick} userToken={userToken} />
            )} */}
            {/* {isLawsUserLogged &&
                ecosystemFunctions instanceof Object &&
                ecosystemFunctions.create_digests && ( */}
            {isLawsUserLogged &&
                isLawsAvailable &&
                ecosystemFunctions instanceof Object &&
                ecosystemFunctions.calendar && <CalendarTab onClick={onClick} />}

            {isLawsUserLogged && ecosystemFunctions instanceof Object && ecosystemFunctions.create_digests && (
                <LawsDigestsOldTab onClick={onClick} />
            )}
            {isLawsUserLogged && ecosystemFunctions instanceof Object && ecosystemFunctions.come_to_force_digests && (
                <LawsDigestsTab onClick={onClick} />
            )}
            {/* <NewsDigestsTab onClick={onClick} /> */}
            {(!isUserLogged || (isNewsUserLogged && isNewsAvailable)) && <NewsDigestsTab onClick={onClick} />}
            {isLawsUserLogged && ecosystemFunctions instanceof Object && ecosystemFunctions.create_reports && (
                <StatisticsTab onClick={onClick} />
            )}
            {isLawsUserLogged &&
                ecosystemFunctions instanceof Object &&
                (ecosystemFunctions.download_todo_reports || ecosystemFunctions.download_essential_reports) && (
                    <ReportsTab onClick={onClick} />
                )}
            {isLawsUserLogged && ecosystemFunctions instanceof Object && ecosystemFunctions.theme_reports && (
                <ThemeReportsTab onClick={onClick} />
            )}
            {isLawsUserLogged && ecosystemFunctions instanceof Object && ecosystemFunctions.create_risk_map && (
                <RiskCardTab onClick={onClick} />
            )}
        </nav>
    );
}

Nav.propTypes = {
    userToken: PropTypes.string,
    isNewsUserLogged: PropTypes.bool,
    isLawsUserLogged: PropTypes.bool,
    isNewsAvailable: PropTypes.bool,
    isLawsAvailable: PropTypes.bool,
    ecosystemFunctions: PropTypes.object,
    onClick: PropTypes.func,
};

const mapStateToProps = (state) => ({
    userToken: state.user.ut,
    isNewsUserLogged: !checkUserExpirationDateExpired(state.user.newsUser.token_expires_at),
    isLawsUserLogged: !checkUserExpirationDateExpired(state.user.lawsUser.token_expires_at),
    isNewsAvailable: state.user.feed_settings && state.user.feed_settings.news,
    isLawsAvailable: state.user.feed_settings && state.user.feed_settings.laws,
    ecosystemFunctions: state.user.ecosystem.functions,
    // groupEcosystemFunctions: state.user.ecosystem.functions
});

export default connect(mapStateToProps)(Nav);



// WEBPACK FOOTER //
// ./src/components/navigation/nav/index.js